import React, { Component } from "react";
import {Button, Form} from "react-bootstrap";
import {connect} from "react-redux";
import {dataSourceHandleActions, msgDataSourceActions} from "_actions";
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from "moment";
import {Field, reduxForm} from "redux-form";
import { DropDownSelect } from "../common";
import { DateRange } from 'components/common/formFields/DateRange'
import {MultiSelectContextMenu} from "../common";
import styles from "./Styles.module.css"

const INCOMING = 'incoming';
const dropdownStyles = {
    borderColor: "#c4c9c7",
    boxShadow: "none",
    color: "#5a5f5e",
    width: "100%"
};

const platformConstants = {
    trends: 'trends',
    teams: 'teams-only'
};

class FilterFormV2 extends Component {

    state = {
        dateRanges: {
            'Today': [moment(), moment()],
            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
            'Month to Date': [moment().startOf('month'), moment()],
            'Year to date': [moment().startOf('year'), moment()],
            'Previous Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        }
    };
    handleOrgChange = (event) => {
        const params = {organization: event.target.value};
        this.props.dispatch(msgDataSourceActions.getAll(params));
    };

    updateHandles = (organizations, handleStatus) => {
        this.props.dispatch(dataSourceHandleActions.getAll({
            organizations: organizations,
            max: 1000,
            handleStatus: this.props.platform === platformConstants.teams ? handleStatus : null
        }));
    };

    render() {
        let {
            submitting,
            onFormUpdate,
            onFormSubmit,
            messageStatus,
            messageStatusOptions,
            onDatePickerUpdate,
            startDate,
            handleStatus,
            direction,
            endDate,
            platform,
            handleChange,
            messageDuration,
            channelsAction,
            channelsIds,
            organizations,
            companiesIds,
            channelsFilter,
            companies,
            handleChannelsFilterChange,
            handleOrgFilterChange,
            dataSourceLoading,
        } = this.props;

        const channelsInput = {onChange: handleChange, value: channelsAction};

        const handleStatusOptions = [
            {name: 'Live', id: 'LIVE'},
            {name: 'Practice', id: 'PRACTICE'},
        ];

        const messageDurationOptions = [
            {name: 'Within two months', id: 'two_months'},
            {name: 'All Period', id: 'all_period'},
        ];

        const messageDirectionOptions = [
            {name: 'All', id: 'ALL'},
            {name: 'Incoming', id: 'INCOMING'},
            {name: 'Outgoing', id: 'OUTGOING'},
        ];

        const itemsConstant = {
            OUTGOING: 'OUTGOING',
            LIVE: 'LIVE'
        };

        const platformFilter = [{id: 'trends', name: 'trends'}, {id: 'teams-only', name: 'teams-only'}];
        const platformInput = {onChange: onFormUpdate, value: platform};
        const handleStatusInput = {onChange: onFormUpdate, value: handleStatus};
        const messageDirectionInput = {onChange: onFormUpdate, value: direction};
        const messageStatusInput = {onChange: onFormUpdate, value: messageStatus};
        const organizationOptions = companies && companies.length > 0 ? companies.map(company => {
            return {name: company.name, value: company.value}
        }) : [];
        const messageDurationInput = {onChange: onFormUpdate, value: messageDuration};

        return (
            <Form inline onSubmit={onFormSubmit} className="messages-page-filter-form">
                <div>
                    <span className="font-14 color-grey-dark">Date</span>
                    <label className={`calendar-today tms-inbox-calendar ${styles["displayBlock"]}`}>
                        <Field
                            submittedStartDate={startDate}
                            submittedEndDate={endDate}
                            id="datePicker"
                            name="datePicker"
                            defaultDateRange="today"
                            onEvent={onDatePickerUpdate}
                            values={startDate}
                            // placeholder={`${startDate} - ${endDate}`}
                            component={DateRange}
                        />
                    </label>
                </div>

            <div className={styles.mt10}>
                <span className="font-14 color-grey-dark">Database</span>
                <label className={styles.displayBlock}>
                    <Field
                        name="platform"
                        fieldName="platform"
                        input={platformInput}
                        className={styles.dropdownStyles}
                        options={platformFilter}
                        value={platform}
                        component={DropDownSelect}/>
                </label>
            </div>

            <div className={styles.mt10}>
                <span className="font-14 color-grey-dark">Organizations</span>
                <div className={`inbox-context-menu ${styles["displayBlock"]}`}>
                    <Field
                        name="organizations"
                        fieldName="organizations"
                        type="text"
                        displayName={'Organizations'}
                        input={channelsInput}
                        options={organizationOptions}
                        checkedOptions={organizations}
                        ids={companiesIds}
                        handleChange={handleOrgFilterChange}
                        component={MultiSelectContextMenu}/>

                </div>
            </div>
            <div className={styles.mt10}>
                <span className="font-14 color-grey-dark">Data Source Handles</span>
                <div className={`inbox-context-menu ${styles["displayBlock"]}`}>
                    <Field
                        name="channels"
                        fieldName="channels"
                        type="text"
                        displayName={'Channels'}
                        input={channelsInput}
                        options={channelsFilter}
                        checkedOptions={channelsAction}
                        ids={channelsIds}
                        handleChange={handleChannelsFilterChange}
                        component={MultiSelectContextMenu}
                        loading={dataSourceLoading}/>
                </div>
            </div>

            {platform !== platformConstants.trends &&
            <div className={styles.mt10}>
                <span className="font-14 color-grey-dark">Handle Status</span>
                <label className={styles.displayBlock}>
                    <Field
                        name="handleStatus"
                        fieldName="handleStatus"
                        input={handleStatusInput}
                        className={styles.dropdownStyles}
                        options={handleStatusOptions}
                        value={handleStatus}
                        component={DropDownSelect}/>
                </label>
            </div>
            }

            <div className={styles.mt10}>
                <span className="font-14 color-grey-dark">Message Direction</span>
                <label className={styles.displayBlock}>
                    <Field
                        name="direction"
                        fieldName="direction"
                        input={messageDirectionInput}
                        className={styles.dropdownStyles}
                        options={messageDirectionOptions}
                        value={direction}
                        component={DropDownSelect}/>
                </label>
            </div>

            {direction && direction.toLowerCase() === INCOMING &&
            <div className={styles.mt10}>
                <span className="font-14 color-grey-dark">Message Status</span>
                <label className={styles.displayBlock}>
                    <Field
                        name="messageStatus"
                        fieldName="messageStatus"
                        input={messageStatusInput}
                        className={styles.dropdownStyles}
                        options={messageStatusOptions}
                        value={messageStatus}
                        component={DropDownSelect}/>
                </label>
            </div>}

            <div className={styles.mt10}>
                <span className="font-14 color-grey-dark">Duration</span>
                <label className={styles.displayBlock}>
                    <Field
                        name="messageDuration"
                        fieldName="messageDuration"
                        input={messageDurationInput}
                        className={styles.dropdownStyles}
                        options={messageDurationOptions}
                        value={messageDuration}
                        component={DropDownSelect}/>
                </label>
            </div>


            <div className={styles.mt15}>
                <Button bsStyle="success" type="submit" disabled={submitting} className={styles.fullWidth}>
                    <i className='fa fa-filter'/> Filter
                </Button>
            </div>
        </Form>
        );
    }
}

const mapStateToProps = (state) => {
    const {auth, messages, msgDataSources, dataSourceHandles} = state;
    return {
        currentUser: auth,
        authors: messages.authors,
        msgDataSources: msgDataSources.msgDataSources,
        dataSourceLoading: dataSourceHandles.loading,
    };
};

FilterFormV2 = connect(mapStateToProps)(FilterFormV2);
const filterFormV2 = reduxForm({
    form: 'FilterFormV2'
})(FilterFormV2);

export { filterFormV2 as FilterFormV2 }
